var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list',{staticClass:"pb-0",style:(_vm.listStyle),attrs:{"dense":""}},[_vm._l((_vm.lineItems),function(lineItem,index){return [_c('LineItemListItem',{key:lineItem.uuid,attrs:{"line-item":lineItem,"order-state":_vm.orderState}}),(index < _vm.lineItems.length - 1)?_c('v-divider',{key:index}):_vm._e()]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }